import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1f7p8ul7e0: FaireBrandEntity = {
  token: "b_1f7p8ul7e0",
  type: "brand",
  name: "CAPELLA APPAREL",
  avatarUrl:
    "https://cdn.faire.com/fastly/95f16e2319736cd83dc9e56d7d13ac5c0f8ecca30526d4246b41140af6e64043.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ea6c1ce8ff85ccf80e5d9bc580119800625602c0fc2710429dfc31b4d918c116.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/95f16e2319736cd83dc9e56d7d13ac5c0f8ecca30526d4246b41140af6e64043.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ea6c1ce8ff85ccf80e5d9bc580119800625602c0fc2710429dfc31b4d918c116.jpeg",
  location: "Vernon, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 874,
  isInsider: true,
  description:
    "Capella Apparel began its journey in 2004 as a women’s clothing manufacturer and wholesaler in Los Angeles, California. A decade later in 2014 Capella Apparel transitioned from running a small brick and mortar store into the E-commerce space providing the needs of vendors from all over the world. Now, Capella Apparel has transitioned into a manufacturer, wholesaler, and drop shipper to provide more services to our customers and customer segments. Capella Apparel’s extensive history of adapting with the current market trends shows the willingness and dedication of our team to fulfill the needs of the customers in both our product and services. Due our long history in the manufacturing business, our prices are highly competitive within the industry, allowing our customers to produce higher profit margins for their business whether it be for wholesaling or drop ship. We will make sure you are profitable with our products! We design and manufacture all our products at Capella Apparel to ensure affordable products and great quality that customers will love. We appreciate all business done with Capella Apparel.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:56.578Z",
    importedBy: "entity-db-cli",
  },
};
